import Vue from "vue";

const eventComponent = new Vue();

class GlobalEvent {
  $on(eventName, callback) {
    return eventComponent.$on(eventName, callback);
  }

  $emit(eventName, params) {
    return eventComponent.$emit(eventName, params);
  }
  
  $once(eventName, params) {
    return eventComponent.$once(eventName, params);
  }
}

const globalEvent = new GlobalEvent();
export default globalEvent;
